import * as React from 'react';
import { useState } from 'react';
import Box from "@material-ui/core/Box";
import { ApplicationState } from "../../redux/reducers";
import { connect } from "react-redux"
import { setSolicitud, setSolicitudCopia } from "../../redux/actions/solicitudActions";
import { ITipoEnvio } from "../../entities/catalogos/ITipoEnvio";
import NextButton from "../controls/NextButton";
import { useSnackbar } from 'notistack';
import { Accordion, AccordionDetails, AccordionSummary, Button, Grid, Typography, Theme } from "@material-ui/core";
import TipoEnvio from "./TipoEnvio";
import { enums } from "../../enums/enums";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import { Mercancia } from "../../entities/solicitudes/Mercancia";
import { ICliente } from "../../entities/catalogos/ICliente";
import { CotizacionDto, ICotizacionDto } from '../../entities/cotizaciones/ICotizacionDto';
import useCommonApi from '../../api/useCommonApi';
import { ICotizacionHistorialDto } from '../../entities/cotizaciones/ICotizacionHistorialDto';
import swal from 'sweetalert2'
import LoadingDialog from '../controls/LoadingDialog';
import { IUsuario } from '../../entities/catalogos/IUsuario';
import { initialSolicitud } from '../../redux/reducers/solicitudReducer';
import { initialRecoleccionState } from '../../redux/reducers/recoleccionReducer';
import { saveMercancias } from '../../redux/actions/mercanciaActions';
import { setRecoleccionDestino, setRecoleccionOrigen } from '../../redux/actions/recoleccionActions';
import { initialMercancia } from '../../redux/reducers/mercanciaReducer';
import { useHistory } from "react-router-dom";
import { setUsuario } from '../../redux/actions/usuarioActions';
import Help, { IHelp } from '../help/Help';
import {setServiciosAdicionales} from "../../blocks/utility";
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Add } from '@material-ui/icons';
import { IEvent } from '../../interfaces/IEvent';
import Markup from '../markup/Markup';
import { IResultApi } from '../../interfaces/IResultApi';
import { saveCliente } from '../../redux/actions/clienteActions';
import { CotizacionDocumentoHistorialDto } from '../../entities/cotizaciones/ICotizacionDocumentoHistorialDto';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({

        heading: {
            fontSize: "0.875rem",
            color: "#00653b",
            fontWeight: theme.typography.fontWeightBold,
            borderBottom: "2px solid #00653b"
        },
        border: {
            fontSize: theme.typography.pxToRem(20),
            fontWeight: theme.typography.fontWeightBold,
            textAlign: "center"
        },
        actions: {
            width: "100%",
            textAlign: "right",
            paddingTop: "20px",
            backgroundColor: "#ccc"
        },
        link: {
            color: "#0094ff",
            fontSize: "12px",
            fontWeight: 500,
            cursor: "pointer"
        }
    }),
);

interface OwnProps {
    //siguienteSeccion: (estatusId: number, cotizacionCopia: Solicitud) => void
    siguienteSeccion: (estatusId: number, cotizacionCopia: Solicitud, cotizacionDTO: any) => void
    cotizacionId: number
}

interface StateProps {
    solicitud: Solicitud
    solicitudCopia: Solicitud
    mercancias: Mercancia[]
    cliente: ICliente
    usuario: IUsuario
    tiposEnvio: ITipoEnvio[]
    ayuda: IHelp
    solicitudDTO: any
    cotizacionDTO: any
    cotizacionResultaMarkup: any 
}

interface DispatchProps {
    setSolicitudCopia: typeof setSolicitudCopia
    setSolicitud: typeof setSolicitud
    saveMercancias: typeof saveMercancias
    setRecoleccionOrigen: typeof setRecoleccionOrigen
    setRecoleccionDestino: typeof setRecoleccionDestino
    setUsuario: typeof setUsuario
    saveCliente: typeof saveCliente
}

interface IResultAuthApi extends IResultApi {
    response: { token: string, refreshToken: string }
}

interface IDatosLogin {
    resultAuthApi: IResultAuthApi
    cliente: ICliente
    etiquetas: any,
    idioma: string,
    diasRAD: string,
    tieneConveniosHD: boolean
}

type Props = OwnProps & StateProps & DispatchProps & IDatosLogin
const apiSource = useCommonApi();

const TipoEnvioLista = (props: Props) => {
    const [state, setState] = useState<Solicitud>(props.solicitudCopia);
    const { enqueueSnackbar } = useSnackbar();
    const apiSourceCommon = useCommonApi();
    const [showLoading, setLoading] = useState(false);
    const [errorCotizacion, setErrorCotizacion] = useState(false);
    const history = useHistory();
    const [tiposEnvioIcono] = useState<any[]>([
        {id: 1, icono: "SERVICIO_ALMEX"},
        {id: 2, icono: "ALMEX_PRIORITY"},
        {id: 3, icono: "ALMEX_PROXIMITY"},
        {id: 4,  icono: "ALMEX_ONE"},
    ]);
    let panelExpand = "TipoEnvio";
    let habilitaMark = true;
    if(props.solicitud.completadaMarkup && (props.cliente.habilitarClienteLogistico && props.cliente.clienteConfiguracionMarkupDetalle.activo)){
        panelExpand="Markup";
        habilitaMark = false;
    }
    const [markupHabilitado, setMarkupHabilitado] = useState(habilitaMark);
    const [expanded, setExpanded] = useState<string | false>(panelExpand);
    let tipoMarkup = 0;
    if(props.solicitudCopia.tipoMarkupId !== undefined && props.solicitudCopia.tipoMarkupId!== null)
        tipoMarkup = props.solicitudCopia.tipoMarkupId;
    const [tipo, setTipo] = useState(tipoMarkup);
    const classes = useStyles();
    const [totalValidaMarkup, setTotalValidaMarkup] = useState(0);
    const [montoMarkup, setMontoMarkup] = useState(0);
    const [porcentajeMarkup, setPorcentajeMarkup] = useState(0);
    const [tipoMarkupId, setTipoMarkupId] = useState(0);
    const [esInternamiento, setEsInternamiento] = useState(props.solicitud.cruceFronterizo?.esIntraUSA ?? false);

    React.useEffect(() => {
        if (!state.tipoEnvio || !props.tiposEnvio.some(e=> e.id === state.tipoEnvio?.id)) {
            let tipoEnvios = {
                id: 1,
                nombre: traducirMessage(261),
                descripcion: '',
                detalle: '',
                seleccionado: true,
                icono:'SERVICIO_ALMEX'
            }
            const copiaSolicitud = new Solicitud(props.solicitudCopia);

            copiaSolicitud.tipoEnvio = tipoEnvios;
            copiaSolicitud.tipoEnvioId = 1;
            setSolicitudCopia(copiaSolicitud);
            setState(copiaSolicitud);

        }
    }, []);

    const correoCall = async (cotizacionId) => {
        const result = await apiSourceCommon.postAsync<any>("/cotizacion/enviar-correo-cotizacion/" + cotizacionId, {username: localStorage.getItem("usuario_nombre")});
        return result;
    }

    const generarCotizacionSinHD = async (cotizacionSinHD:any) => {
        let cotizacionHD = setCotizacionDto();
        cotizacionHD.tipoServicioID = cotizacionSinHD.tipoServicio.id;
        cotizacionHD.esHomeDelivery = cotizacionSinHD.esHomeDelivery;
        return guardarCotizacion(cotizacionHD);
    }

    const generarCotizacion = async () => {

        if(esInternamiento){//folio 3823
            await swal.fire({
                titleText: traducirMessage(11),
                text: traducirMessage(324), // 'El cruce fronterizo no es válido para el servicio Intra USA.',
                type: 'info'
            });
        }///fin 3823

        if (!state.tipoEnvio) {
            enqueueSnackbar(traducirMessage(118), // "Favor de seleccionar el tipo de envío.", 
            { variant: "error" });
            return
        }

        setLoading(true);
        validarCotizacionMarkup().then(resultCotizacion => { 

            setLoading(false);
            if((props.cliente.habilitarClienteLogistico && !props.cliente.clienteConfiguracionMarkupDetalle.activo) 
                        || (!props.cliente.habilitarClienteLogistico && !props.cliente.clienteConfiguracionMarkupDetalle.activo)
                        || (!props.cliente.habilitarClienteLogistico && props.cliente.clienteConfiguracionMarkupDetalle.activo)){
                            setNuevaCotizacion(resultCotizacion);                       
                        }
            if(props.cliente.habilitarClienteLogistico && props.cliente.clienteConfiguracionMarkupDetalle.activo){
                let totalMonto = 0;
                resultCotizacion.cotizacionDesgloseFlete?.forEach(function(element){
                    totalMonto = totalMonto + element.valor;
                });

                resultCotizacion.cotizacionDesgloseFleteEad?.forEach(function(element){
                    totalMonto = totalMonto + element.valor;
                });

                resultCotizacion.cotizacionDesgloseFleteRad?.forEach(function(element){
                    totalMonto = totalMonto + element.valor;
                });
                setTotalValidaMarkup(totalMonto);
                setExpanded('Markup');
                setMarkupHabilitado(false);
            }
        
        }).catch(err => {

            let messageError = !!err.data ? err.data.error.message : err;
            if(typeof messageError === "object"){
                messageError = messageError.message ?? "";
            }
            console.log(messageError);
            setLoading(false);
            if(messageError.includes("ERROR TARIFA HOME DELIVERY")){
                
                swal.fire({
                    titleText: traducirLabel(343), //'Tipo de Servicio',
                    text: traducirMessage(310),
                    type: 'warning',
                    showConfirmButton: true,
                    showCancelButton: true,
    
                    cancelButtonAriaLabel: traducirButton(6), // 'CANCELAR',
                    confirmButtonAriaLabel: traducirButton(17), // 'ACEPTAR'
                
                }).then((result) => {
                    if (result.value == true) {
                        setLoading(true);
                        const copiaSolicitud = new Solicitud(props.solicitudCopia);
                        copiaSolicitud.tipoServicio = copiaSolicitud.tipoServicioReal;
                        copiaSolicitud.esHomeDelivery = false;
                        // props.setSolicitud(copiaSolicitud);
                        // props.setSolicitudCopia(copiaSolicitud);
                        // props.siguienteSeccion(enums.estatusSolicitud.tipoEnvio, copiaSolicitud, null);
                        generarCotizacionSinHD(copiaSolicitud).then(resultCotizacion => { 
                            //setLoading(false);
                            setLoading(true);
                            setNuevaCotizacion(resultCotizacion);
                            
                        }).catch(err => { console.log(err); })
                    }
                })
            }else if(messageError.includes("timeout") || messageError.includes("EnableRetryOnFailure()")){
                swal.fire({
                    titleText: traducirLabel(349),
                    text: traducirMessage(323),
                    type: "error"
                  });
            }
            else{
                swal.fire({
                    titleText: traducirMessage(272),//'¡Error!'
                    text: messageError.includes("FAVOR DE VERIFICAR SELECCIONAR UNA CLASE VALIDA") ? traducirMessage(306) : messageError.includes("PLEASE VERIFY AND SELECT A VALID CLASS") ? traducirMessage(306) : messageError,
                    type: 'error',
                }).then((result) => {
                    if(result.value && (messageError.includes("FAVOR DE VERIFICAR SELECCIONAR UNA CLASE VALIDA") || messageError.includes("PLEASE VERIFY AND SELECT A VALID CLASS"))){
                        const copiaSolicitud = new Solicitud(props.solicitudCopia);
                        copiaSolicitud.claseId = -1;
                        props.siguienteSeccion(enums.estatusSolicitud.datosMercancia, copiaSolicitud, null);
                    }
                });
            }
        });
        
    };

    const servicioAdicionalGuardado = (nombre: string) => {

        let value = 0;
        if (props.solicitud.serviciosAdicionales?.length) {
            let found = props.solicitud.serviciosAdicionales.filter(t => t.nombre === nombre);
            if (found.length) {
                value = 1;
            }
        }
        return value;
    }

    const setCitaHorario=()=>{



        let citaHorario= {

            cotizacionId: props.cotizacionId,
            fechaCitaRad: new Date(1900,0,1),
            radCitaHoraInicio: props.solicitud.RadCitaHoraDe,
            radCitaHoraFinal: props.solicitud.RadCitaHoraHasta,
            fechaCitaEad: new Date(1900,0,1),
            eadCitaHoraInicio: props.solicitud.EadCitaHoraDe,
            eadCitaHoraFinal: props.solicitud.EadCitaHoraHasta,
            fechaCitaRadCedis: new Date(1900,0,1),
            fechaCitaEadCedis: new Date(1900,0,1)
        }
        if(props.solicitud.fechaCitaRad !== null && props.solicitud.fechaCitaRad !== undefined)
        {
            citaHorario.fechaCitaRad = new Date(props.solicitud.fechaCitaRad);
        }
        if(props.solicitud.fechaCitaEad !== null && props.solicitud.fechaCitaEad !== undefined)
        {
            citaHorario.fechaCitaEad = new Date(props.solicitud.fechaCitaEad);
        }
        if(props.solicitud.fechaCitaRadCedis !== null && props.solicitud.fechaCitaRadCedis !== undefined)
        {
            citaHorario.fechaCitaRadCedis = new Date(props.solicitud.fechaCitaRadCedis);
        }
        if(props.solicitud.fechaCitaEadCedis !== null && props.solicitud.fechaCitaEadCedis !== undefined)
        {
            citaHorario.fechaCitaEadCedis = new Date(props.solicitud.fechaCitaEadCedis);
        }

        return citaHorario;
    }

    const setMercancias = () => {
        let mercancias = [
            {
                cotizacionID: 0,
                cotizacionMercanciaID: 0,
                cantidad: 0,
                embalajeID: 0,
                largo: 0,
                ancho: 0,
                alto: 0,
                peso: 0,
                volumen: 0,
                esNoEstibable: 0,
                convenioID: 0,
                tarifarioID: 0,
                noTarima: 0,
                //auditFecha: undefined,
                auditUsuarioID: 0,
                auditPCMod: "",
                densidad: 0,
                pesoFacturado: 0,
                servicioID: 0,
                altoReal: 0
            }
        ];
        if (props.mercancias?.length) {
            mercancias = [];
            props.mercancias.forEach(s => {
                mercancias.push({
                    cotizacionID: props.cotizacionId,
                    cotizacionMercanciaID: s.id,
                    cantidad: s.cantidad ? s.cantidad : 0,
                    embalajeID: s.embalajeId ? s.embalajeId : 0,
                    largo: s.largo ? s.largo : 0,
                    ancho: s.ancho ? s.ancho : 0,
                    alto: s.alto ? s.alto : 0,
                    peso: s.peso ? s.peso : 0,
                    volumen: s.volumen ? s.volumen : 0,
                    esNoEstibable: s.esEstibable ? 1 : 0,
                    convenioID: 0,
                    tarifarioID: 0,
                    noTarima: 0,
                    //  auditFecha: undefined,
                    auditUsuarioID: 0,
                    auditPCMod: "",
                    densidad: 0,
                    pesoFacturado: 0,
                    servicioID: 0,
                    altoReal: s.altoReal ? s.altoReal : 0
                })

            });
        }
        return mercancias;
    }

    const setComercioExterior = () => {
        let comercioExterior = props?.solicitud?.comercioExterior;
        if(comercioExterior == undefined || comercioExterior == null)
            return null;

        return {    
                    cotizacionId: props?.cotizacionId ?? 0,
                    cotizacionComercioExteriorId: comercioExterior.solicitudComercioExteriorId ?? 0,
                    tipoComercioExteriorId: comercioExterior.tipoComercioExteriorId
        };
    }

    const setCruceFronterizo = () => {
        let cruceFronterizo = props?.solicitud?.cruceFronterizo;
        if(cruceFronterizo == undefined || cruceFronterizo == null)
            return null;

        let cruce = {
            cotizacionComercioExteriorId: cruceFronterizo.solicitudComercioExteriorId,
            tipoServicioInternacionalId: cruceFronterizo.tipoServicioInternacionalId,
            tipoMovimientoServicioInternacionalId: cruceFronterizo.tipoMovimientoServicioInternacionalId,
            cruceInternacionalId: cruceFronterizo.cruceInternacionalId,
            esIntraUSA: cruceFronterizo.esIntraUSA,
            cotizacionId: props?.cotizacionId ?? 0,
        };
        return cruce;
    }

    const setCotizacionDto = (): ICotizacionDto => {
        const cotizacionID = props.solicitudCopia.solicitudId || props.solicitudCopia.id || 0;
        props?.solicitud?.fechaCitaRad?.setMinutes(props?.solicitud?.fechaCitaRad?.getMinutes() - props?.solicitud?.fechaCitaRad?.getTimezoneOffset())
        props?.solicitud?.fechaCitaEad?.setMinutes(props?.solicitud?.fechaCitaEad?.getMinutes() - props?.solicitud?.fechaCitaEad?.getTimezoneOffset())
        props?.solicitud?.fechaCitaRadCedis?.setMinutes(props?.solicitud?.fechaCitaRadCedis?.getMinutes() - props?.solicitud?.fechaCitaRadCedis?.getTimezoneOffset())
        props?.solicitud?.fechaCitaEadCedis?.setMinutes(props?.solicitud?.fechaCitaEadCedis?.getMinutes() - props?.solicitud?.fechaCitaEadCedis?.getTimezoneOffset())

        let fechaCitaRad = props?.solicitud?.fechaCitaRad;
        let fechaCitaEad = props?.solicitud?.fechaCitaEad;
        let fechaCitaRadCedis = props?.solicitud?.fechaCitaRadCedis;
        let fechaCitaEadCedis = props?.solicitud?.fechaCitaEadCedis;
        const  fa=new Date(fechaCitaRad??'');
        const  de= new Date(fechaCitaEad??'')
        const  faCedis=new Date(fechaCitaRadCedis??'');
        const  deCedis= new Date(fechaCitaEadCedis??'')
        let retorna={
            cotizacionID,
            numCotizacion: "",
            empresaID: 0,
            estatusCotizacionID: 0,
            clienteID: props.cliente.id,
            correo: props.solicitud.correo != null ? props.solicitud.correo : "",
            ocurreOrigen: Number(props.solicitud?.ocurreOrigen),
            paisIdOrigen: props.solicitud?.coloniaOrigen?.pais.id ? props.solicitud?.coloniaOrigen?.pais?.id : 0,
            estadoIdOrigen: props.solicitud?.coloniaOrigen?.estado.id ? props.solicitud?.coloniaOrigen?.estado.id : 0,
            ciudadIdOrigen: props.solicitud?.coloniaOrigen?.ciudad?.id ? props.solicitud?.coloniaOrigen?.ciudad?.id : 0,
            coloniaIdOrigen: props.solicitud?.coloniaOrigen?.id ? props.solicitud?.coloniaOrigen?.id : 0,
            codigoPostalOrigen: props.solicitud?.coloniaOrigen?.codigoPostal ? props.solicitud?.coloniaOrigen?.codigoPostal : "",
            ocurreDestino: Number(props.solicitud?.ocurreDestino),
            paisIdDestino: props.solicitud?.coloniaDestino?.pais.id ? props.solicitud?.coloniaDestino?.pais?.id : 0,
            estadoIdDestino: props.solicitud?.coloniaDestino?.estado.id ? props.solicitud?.coloniaDestino?.estado.id : 0,
            ciudadIdDestino: props.solicitud?.coloniaDestino?.ciudad?.id ? props.solicitud?.coloniaDestino?.ciudad?.id : 0,
            coloniaIdDestino: props.solicitud?.coloniaDestino?.id ? props.solicitud?.coloniaDestino?.id : 0,
            codigoPostalDestino: props.solicitud?.coloniaDestino?.codigoPostal ? props.solicitud?.coloniaDestino?.codigoPostal : "",
            sucursalClienteID: 0,
            sucursalRemitenteID: props.solicitud?.sucursalOrigen?.id ?? 0,
            sucursalDestinatarioID: props.solicitud?.sucursalDestino?.id ?? 0,
            areaServicioClienteID: 0,
            areaServicioRemitenteID: props?.solicitud?.areaServicioOrigenId ? props?.solicitud?.areaServicioOrigenId : 0,
            areaServicioDestinatarioID: props?.solicitud?.areaServicioDestinoId ? props?.solicitud?.areaServicioDestinoId : 0,
            direccionCliente: "",
            direccionRemitente: "",
            direccionDestinatario: "",
            tipoServicioID: props.solicitudCopia.tipoServicio?.id ? props.solicitudCopia.tipoServicio?.id : Number(props.solicitud.tipoServicio?.id),
            tipoEnvioID: state.tipoEnvio?.id?? 0,
            proyectoID: props.solicitudCopia.proyecto != undefined ? props.solicitudCopia.proyecto?.id : 0,
            esFlete: 0,
            esRAD: (props?.solicitudCopia?.tipoRecoleccionIdOrigen === enums.tipoRecoleccion.residencial)?1:   Number(props?.solicitud?.esRad),
            fechaCitaRAD: props?.solicitud?.fechaCitaRad ? new Date(fa)  : undefined,
            fechaCitaRADCedis: props?.solicitud?.fechaCitaRadCedis ? new Date(faCedis)  : undefined,
            esEAD: (props?.solicitudCopia?.tipoRecoleccionIdDestino === enums.tipoRecoleccion.residencial)?1: Number(props?.solicitud?.esEad),
            fechaCitaEAD: props?.solicitud?.fechaCitaEad ? new Date(de)  : undefined,
            fechaCitaEADCedis: props?.solicitud?.fechaCitaEadCedis ? new Date(deCedis)  : undefined,
            esSeguroMercancia: props.solicitudCopia?.esSeguroMercancia ? 1 : 0,
            esSeguroBasico: props.solicitudCopia?.esSeguroBasico ? 1 : 0,
            esCobrarEnDestino: servicioAdicionalGuardado("COBRO EN DESTINO") == 0 ? 0 : 1,
            valorMercancia: props?.solicitud.valorMercancia ? props?.solicitud.valorMercancia : 0,
            unidadMedidaMercanciaID: props.solicitudCopia?.unidadMedidaPesoId ? props.solicitudCopia?.unidadMedidaPesoId : 0,
            unidadMercanciaID: props.solicitudCopia?.unidadMedidaLongitudId ? props.solicitudCopia?.unidadMedidaLongitudId : 0,

            claseID: props.solicitudCopia.claseId != undefined ? props.solicitudCopia.claseId : 0,
            //clase: props.solicitudCopia.clase != undefined ? props.solicitudCopia.clase : '',
            descripcionMercancia: props.solicitudCopia.descripcionMercancia ? props.solicitudCopia.descripcionMercancia : "",
            fechaEnvioEstimado: undefined,
            fechaAlta: undefined,
            descuento: 0,
            totalCantidadMercancia: 0,
            totalPesoMercancia: 0,
            totalVolumenMercancia: 0,
            totalPesoVolumen: 0,
            totalPesoFacturado: 0,
            monedaID: 0,
            tipoCambio: 0,
            ivaID: 0,
            retencionID: 0,
            markupMonto: montoMarkup ?? 0,
            markupPorcentaje: porcentajeMarkup ?? 0,
            tipoMarkupId: tipoMarkupId ?? 0,
            iva: props?.solicitud.iva ? props?.solicitud.iva : 0,
            retencion: props?.solicitud.retencion ? props?.solicitud.retencion : 0,
            subTotal: props?.solicitud.subtotal ? props?.solicitud.subtotal : 0,
            total: props?.solicitud.total ? props?.solicitud.total : 0,
            esAceptaTerminosCondiciones: 0,
            auditFecha: undefined,
            auditUsuarioID: props.usuario.id,
            auditPCMod: props.usuario.nombre,
            montoCobroEnDestino: 0,
            tipoUsuarioId: 0,
            esEadCita: 0,
            esRadCita: 0,
            esRetornoDocumento: servicioAdicionalGuardado("RETORNO DOCUMENTOS"),
            grupoClienteId: 0,
            grupoProyectoId: 0,
            agrupadorId: 0,
            esPropuesta: 0,
            empresaTarifaAlmex: (props.solicitud.empresaTarifaAlmex != null && props.usuario.esInvitado) ? props.solicitud.empresaTarifaAlmex : "",
            nombreTarifaAlmex: (props.solicitud.nombreTarifaAlmex != null && props.usuario.esInvitado) ? props.solicitud.nombreTarifaAlmex : "",
            telefonoTarifaAlmex: (props.solicitud.telefonoTarifaAlmex != null && props.usuario.esInvitado) ? props.solicitud.telefonoTarifaAlmex : "",
            esParticularTarifaAlmex: (props.solicitud.esParticularTarifaAlmex != null && props.usuario.esInvitado) ? props.solicitud.esParticularTarifaAlmex : 0,
            serviciosAdicionales: setServiciosAdicionales(props.solicitud),
            cotizacionMercancias: setMercancias(),
            esResidencialOrigen: !!props.solicitud?.esResidencialOrigen,
            esResidencialDestino: !!props.solicitud?.esResidencialDestino,
            EsRadCitaFueraHorario: props.solicitud.EsRadCitaFueraHorario,
            EsEadCitaFueraHorario: props.solicitud.EsEadCitaFueraHorario,
            cotizacionCitaHorario: setCitaHorario(),
            idioma: localStorage.getItem("idioma"),
            esHomeDelivery: (props?.solicitudCopia?.tipoServicio && Number(props.solicitudCopia.tipoServicio?.id)!==3) ? false : props.solicitudCopia.esHomeDelivery,
            cotizacionComercioExterior: setComercioExterior(),
            cotizacionCruceFronterizo: setCruceFronterizo()
        };
        return retorna;
    };

    const actualizaLoginData = async (clienteId, usuarioId, userName) => {
        const result = await apiSource.obtenerAsync<IDatosLogin>("login/login-data", { clienteId: clienteId, usuarioId: usuarioId });
        return result;
    };

        const setSucursal = (sucursal: number|undefined, esSucursalOrigen: boolean, paisIdOrigenDestino: number) => {
        let sucursalId = sucursal ?? 0;
        //Para servicios internacionales, reemplazar sucursal origen/destino por sucursal del cruce fronterizo
        if(paisIdOrigenDestino == enums.pais.usa){
            let sucursalCruceId = props.solicitud.cruceFronterizo?.sucursalCruceId ?? 0;
            return sucursalCruceId;
        }else{
            return sucursalId;
        }
    }

    const guardarCotizacion = async (cotizacionDTO:any) => {

        let sucursalOrigenId = props?.solicitud?.sucursalOrigen?.id ?? 0;
        let sucursalDestinoId = props?.solicitud?.sucursalDestino?.id ?? 0;
        cotizacionDTO.sucursalRemitenteID = setSucursal(sucursalOrigenId, true, props?.solicitud?.paisIdOrigen);
        cotizacionDTO.sucursalDestinatarioID = setSucursal(sucursalDestinoId, true, props?.solicitud?.paisIdDestino);
        cotizacionDTO.sucursalRemitente = props?.solicitud?.sucursalOrigen;
        cotizacionDTO.sucursalDestinatario = props?.solicitud?.sucursalDestino;
        cotizacionDTO.coloniaOrigen = props?.solicitud?.coloniaOrigen;
        cotizacionDTO.coloniaDestino = props?.solicitud?.coloniaDestino;
        cotizacionDTO.eliminaRetornoDocumentos = props?.solicitud.eliminaRetornoDocumentos;

        if (cotizacionDTO.cotizacionMercancias != undefined) {
            cotizacionDTO.cotizacionMercancias.forEach(m => {

                const indexEmb = props?.mercancias.findIndex(a => a.embalajeId === m.embalajeID);
                delete m.nombreMercancia;
                m.nombreMercancia = props?.mercancias[indexEmb].embalaje;
                delete m.etiquetaMercancia;
                m.etiquetaMercancia = props?.mercancias[indexEmb].etiquetaEmbalaje.nombre;
            });
        }

        const result = await apiSourceCommon.postAsync<ICotizacionDto>("/cotizacion", cotizacionDTO);
        // let copiaCotizacionDto;
        // if(cotizacionDTO.cotizacionCruceFronterizo != undefined && cotizacionDTO.cotizacionCruceFronterizo != null){
        //     copiaCotizacionDto = new CotizacionDto({ ...cotizacionDTO
        //                                             , esRAD : cotizacionDTO.paisIdOrigen === enums.pais.usa ? 1 : cotizacionDTO.esRAD
        //                                             , esEAD : cotizacionDTO.paisIdDestino === enums.pais.usa ? 1 : cotizacionDTO.esEAD})
        // }
        
        props?.solicitud?.fechaCitaRad?.setMinutes(props?.solicitud?.fechaCitaRad?.getMinutes() + props?.solicitud?.fechaCitaRad?.getTimezoneOffset())
        props?.solicitud?.fechaCitaEad?.setMinutes(props?.solicitud?.fechaCitaEad?.getMinutes() + props?.solicitud?.fechaCitaEad?.getTimezoneOffset())
        props?.solicitud?.fechaCitaRadCedis?.setMinutes(props?.solicitud?.fechaCitaRadCedis?.getMinutes() + props?.solicitud?.fechaCitaRadCedis?.getTimezoneOffset())
        props?.solicitud?.fechaCitaEadCedis?.setMinutes(props?.solicitud?.fechaCitaEadCedis?.getMinutes() + props?.solicitud?.fechaCitaEadCedis?.getTimezoneOffset())
        return result;
    }

    const validarCotizacionMarkup = async () => {
        let cotizacionMarkupDto = setCotizacionDto();
            
        //Cobrar flete desde/hacia sucursal del cruce
        if(props.solicitud?.esServicioInternacional){
            let esRad, esEad, sucursalRemitenteId, sucursalDestinatarioId;

            if(props.solicitud?.esCruceOrigen || cotizacionMarkupDto.paisIdOrigen === enums.pais.usa){
                esRad = cotizacionMarkupDto.esRAD;
                esEad = cotizacionMarkupDto.esEAD;
                sucursalRemitenteId = props.solicitud?.cruceFronterizo?.sucursalCruceId ?? 0;
                sucursalDestinatarioId = cotizacionMarkupDto.sucursalDestinatarioID;
            }
            else{
                esRad = cotizacionMarkupDto.esRAD;
                esEad = cotizacionMarkupDto.esEAD;
                sucursalRemitenteId = cotizacionMarkupDto.sucursalRemitenteID;
                sucursalDestinatarioId = props.solicitud?.cruceFronterizo?.sucursalCruceId ?? 0;
            }

            cotizacionMarkupDto = new CotizacionDto({...cotizacionMarkupDto, 
                                                        esRAD: esRad, esEAD: esEad, 
                                                        sucursalRemitenteID: sucursalRemitenteId, 
                                                        sucursalDestinatarioID: sucursalDestinatarioId});
        } 

        if(props.cliente.habilitarClienteLogistico && props.cliente.clienteConfiguracionMarkupDetalle.activo){
            const result = await apiSourceCommon.postAsync<ICotizacionDto>("/cotizacion/validar-tarifario", cotizacionMarkupDto);
            props?.solicitud?.fechaCitaRad?.setMinutes(props?.solicitud?.fechaCitaRad?.getMinutes() + props?.solicitud?.fechaCitaRad?.getTimezoneOffset())
            props?.solicitud?.fechaCitaEad?.setMinutes(props?.solicitud?.fechaCitaEad?.getMinutes() + props?.solicitud?.fechaCitaEad?.getTimezoneOffset())
            props?.solicitud?.fechaCitaRadCedis?.setMinutes(props?.solicitud?.fechaCitaRadCedis?.getMinutes() + props?.solicitud?.fechaCitaRadCedis?.getTimezoneOffset())
            props?.solicitud?.fechaCitaEadCedis?.setMinutes(props?.solicitud?.fechaCitaEadCedis?.getMinutes() + props?.solicitud?.fechaCitaEadCedis?.getTimezoneOffset())
            return result;
        }
        else{
            return guardarCotizacion(cotizacionMarkupDto);
        }
    }

    const getTotalPesoFacturado = (cotizacion) => {

        var total = 0;
        if (cotizacion.cotizacionDesgloseFlete.length) {
            total = (cotizacion.cotizacionDesgloseFlete.reduce((a,v) => a = a + v.valor, 0)); 
        }
        if (cotizacion.cotizacionDesgloseFleteEad.length) {
            total += cotizacion.cotizacionDesgloseFleteEad[0].valor;
        }
        if (cotizacion.cotizacionDesgloseFleteRad.length) {
            total += cotizacion.cotizacionDesgloseFleteRad[0].valor;
        }
        if (cotizacion.cotizacionDesgloseFleteAjuste.length) {
            total += cotizacion.cotizacionDesgloseFleteAjuste[0].valor;
        }
        if (cotizacion.serviciosAdicionales.length) {
            for(let i=0; i < cotizacion.serviciosAdicionales.length; i++)
            {
                if(cotizacion.serviciosAdicionales[i].id === 480){
                    total +=  cotizacion.serviciosAdicionales[i].costo
                }   
            }
        }
        return total;
    }

    const setNuevaCotizacion = (cotizacion) => {

        var altermercancias = cotizacion.cotizacionMercancias;

        if (altermercancias != undefined) {
            altermercancias.forEach(m => {
                var embalajedescripcion = m.embalaje.nombre;
                if(localStorage.getItem("idioma") === 'en-US'){
                    embalajedescripcion = m.embalaje?.etiquetaEmbalaje?.nombre;
                }
                
                delete m.embalaje;
                m.embalaje = embalajedescripcion
            });
        }
        
        let fechaCitaRadArray = cotizacion.fechaCitaRAD.split('T');
        let fechaCitaEadArray = cotizacion.fechaCitaEAD.split('T');
        let fechaCitaRadDate = fechaCitaRadArray[0].split('-');
        let fechaCitaRadTime = fechaCitaRadArray[1].split(':');
        let fechaCitaEadDate = fechaCitaEadArray[0].split('-');
        let fechaCitaEadTime = fechaCitaEadArray[1].split(':');

        let fechaCitaRadCedisArray = cotizacion.cotizacionRadEadCedis.fechaCitaRADCedis.split('T');
        let fechaCitaEadCedisArray = cotizacion.cotizacionRadEadCedis.fechaCitaEADCedis.split('T');
        let fechaCitaRadCedisDate = fechaCitaRadCedisArray[0].split('-');
        let fechaCitaRadCedisTime = fechaCitaRadCedisArray[1].split(':');
        let fechaCitaEadCedisDate = fechaCitaEadCedisArray[0].split('-');
        let fechaCitaEadCedisTime = fechaCitaEadCedisArray[1].split(':');

        let cotizacionSolicitud = new Solicitud({
            camposInvalidos: [],
            camposRequeridos: [],
            completada: true,
            modificar: true,
            esFormaValida: true,
            esSeguroBasico: cotizacion.esSeguroBasico,
            esSeguroMercancia: cotizacion.esSeguroMercancia,
            estatusId: cotizacion.estatusCotizacionID,
            id: cotizacion.cotizacionID,
            solicitudId: cotizacion.cotizacionID,
            paisIdDestino: cotizacion.paisIdDestino,
            paisIdOrigen: cotizacion.paisIOrigen,
            seccionId: 1,
            serviciosAdicionales: cotizacion.serviciosAdicionales,
            mercancias: altermercancias,
            tipoEnvio: cotizacion.tipoEnvio,
            tipoServicio: cotizacion.tipoServicio,
            coloniaOrigen: props.solicitudCopia.coloniaOrigen,
            sucursalOrigen: props.solicitudCopia.sucursalOrigen,
            unidadMedidaLongitudId: cotizacion.unidadMercanciaID,
            unidadMedidaPesoId: cotizacion.unidadMedidaMercanciaID,
            total: cotizacion.total,
            subtotal: cotizacion.subTotal,
            iva: cotizacion.iva,
            retencion: cotizacion.retencion,
            descuento: cotizacion.descuento,
            markupMonto: cotizacion.markupMonto,
            markupPorcentaje: cotizacion.markupPorcentaje,
            tipoMarkupId: cotizacion.tipoMarkupId,
            montoPesoFacturado: getTotalPesoFacturado(cotizacion),
            totalPesoFacturado: cotizacion.totalPesoFacturado,
            totalPesoMercancia: cotizacion.totalPesoMercancia,
            totalPesoVolumen: cotizacion.totalPesoVolumen,
            valorMercancia: cotizacion.valorMercancia,
            costoSeguro: cotizacion.cotizacionDesgloseFleteSeguro != undefined && cotizacion.cotizacionDesgloseFleteSeguro.length > 0 ? cotizacion.cotizacionDesgloseFleteSeguro[0].valor : 0,
            costoMarkup: cotizacion.markupMonto,
            claseId: cotizacion.claseID,
            clase: cotizacion.clase,
            correo: cotizacion.correo,
            nombreTarifaAlmex: cotizacion.nombreTarifaAlmex,
            empresaTarifaAlmex: cotizacion.empresaTarifaAlmex,
            telefonoTarifaAlmex: cotizacion.telefonoTarifaAlmex,
            esParticularTarifaAlmex: cotizacion.esParticularTarifaAlmex,
            proyecto: props.solicitud.proyecto,
            cotizacionCitaHorario: cotizacion.cotizacionCitaHorario,
            esEad : cotizacion.esEAD,
            esRad: cotizacion.esRAD,
            fechaCitaRad : new Date(fechaCitaRadDate[0],fechaCitaRadDate[1]-1,fechaCitaRadDate[2],fechaCitaRadTime[0],fechaCitaRadTime[1]) ,
            fechaCitaEad:  new Date(fechaCitaEadDate[0],fechaCitaEadDate[1]-1,fechaCitaEadDate[2],fechaCitaEadTime[0],fechaCitaEadTime[1]),
            fechaCitaRadCedis : new Date(fechaCitaRadCedisDate[0],fechaCitaRadCedisDate[1]-1,fechaCitaRadCedisDate[2],fechaCitaRadCedisTime[0],fechaCitaRadCedisTime[1]) ,
            fechaCitaEadCedis:  new Date(fechaCitaEadCedisDate[0],fechaCitaEadCedisDate[1]-1,fechaCitaEadCedisDate[2],fechaCitaEadCedisTime[0],fechaCitaEadCedisTime[1])
        });
        const copiaSolicitud = new Solicitud(cotizacionSolicitud);
        if(props.solicitud.fechaCitaEad === undefined){
            copiaSolicitud.fechaCitaEad=props.solicitud.fechaCitaEad;
        }
        if(props.solicitud.fechaCitaRad === undefined){
            copiaSolicitud.fechaCitaRad=props.solicitud.fechaCitaRad;
        }
        if(props.solicitud.fechaCitaEadCedis === undefined){
            copiaSolicitud.fechaCitaEadCedis=props.solicitud.fechaCitaEadCedis;
        }
        if(props.solicitud.fechaCitaRadCedis === undefined){
            copiaSolicitud.fechaCitaRadCedis=props.solicitud.fechaCitaRadCedis;
        }
        setState(copiaSolicitud);
        setSolicitudCopia(copiaSolicitud);
        setSolicitud(copiaSolicitud);
        setLoading(false);
        props.siguienteSeccion(enums.estatusSolicitud.cotizacion, copiaSolicitud, null);
    }

    const seleccionarTipoEnvio = (tipoEnvio: ITipoEnvio) => {
        const copiaSolicitud = new Solicitud({ ...state, tipoEnvio });
        setState(copiaSolicitud);
        setSolicitudCopia(copiaSolicitud);
    };

    const crearNuevaCotizacion = () => {
        const nuevaCotizacion = new Solicitud(initialSolicitud);

        props.setSolicitud(nuevaCotizacion);
        props.setSolicitudCopia(nuevaCotizacion);
        props.setRecoleccionOrigen(initialRecoleccionState);
        props.setRecoleccionDestino(initialRecoleccionState);
        props.saveMercancias([initialMercancia]);
        props.setUsuario({ ...props.usuario });
        if (props.usuario.esInvitado) {
            history.push("/");
        }
        else {
            history.push("/nueva-cotizacion");
        }

    };

    const getIconoTipoEnvio = (id) => {
        let icono='';
        let tipoEnvioFilter = tiposEnvioIcono.filter(x=> x.id == id)[0];
        icono = id === state.tipoEnvio?.id ?  `${tipoEnvioFilter.icono}_seleccionado.jpg` : `${tipoEnvioFilter.icono}.jpg`;
        return icono;
    }

    const handleChangePanel = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleChangeTipo = (event: React.ChangeEvent<HTMLInputElement> | IEvent) => {
        setTipo(Number(event.target.value));
    }

    const handleSiguienteSeccion = (montoMarkup:any, cotizacion:any, porcentajeMarkup:any) => {
        setMontoMarkup(montoMarkup);
        setPorcentajeMarkup(porcentajeMarkup);
        setTipoMarkupId(cotizacion.tipoMarkupId);
        setLoading(true);
        let cotizacionMarkupDto = setCotizacionDto();
        cotizacionMarkupDto.markupMonto = montoMarkup;
        cotizacionMarkupDto.markupPorcentaje = porcentajeMarkup;
        cotizacionMarkupDto.tipoMarkupId = cotizacion.tipoMarkupId;

        guardarCotizacion(cotizacionMarkupDto).then(resultCotizacion => { 
            setLoading(true);
            resultCotizacion.tipoMarkupId = cotizacion.tipoMarkupId;
            setNuevaCotizacion(resultCotizacion);    
        }).catch(err => {

          //  setErrorCotizacion(true);
            let messageError = !!err.data? err.data.error.message: err;
            setLoading(false);
            if(messageError.includes("ERROR TARIFA HOME DELIVERY")){
                
                swal.fire({
                    titleText: traducirLabel(343), //'Tipo de Servicio',
                    text: traducirMessage(310),
                    type: 'warning',
                    showConfirmButton: true,
                    showCancelButton: true,
    
                    cancelButtonAriaLabel: traducirButton(6), // 'CANCELAR',
                    confirmButtonAriaLabel: traducirButton(17), // 'ACEPTAR'
                
                }).then((result) => {
                    if (result.value == true) {
                        const copiaSolicitud = new Solicitud(props.solicitudCopia);
                        copiaSolicitud.tipoServicio = copiaSolicitud.tipoServicioReal;
                        copiaSolicitud.esHomeDelivery = false;
                        props.setSolicitud(copiaSolicitud);
                        props.setSolicitudCopia(copiaSolicitud);
                        props.siguienteSeccion(enums.estatusSolicitud.tipoEnvio, copiaSolicitud, null);
                    }
                })
            }
            else{
                swal.fire({
                    titleText: traducirMessage(272),//'¡Error!'
                    text: messageError.includes("FAVOR DE VERIFICAR SELECCIONAR UNA CLASE VALIDA") ? traducirMessage(306) : messageError.includes("PLEASE VERIFY AND SELECT A VALID CLASS") ? traducirMessage(306) : messageError,
                    type: 'error',
                }).then((result) => {
                    if(result.value && (messageError.includes("FAVOR DE VERIFICAR SELECCIONAR UNA CLASE VALIDA") || messageError.includes("PLEASE VERIFY AND SELECT A VALID CLASS"))){
                        const copiaSolicitud = new Solicitud(props.solicitudCopia);
                        copiaSolicitud.claseId = -1;
                        props.siguienteSeccion(enums.estatusSolicitud.datosMercancia, copiaSolicitud, null);
                    }
                });
            }
        });
    };

    const handleChange = (event: IEvent) => {
        const name = event.target.name || "";
        console.log("handeChangte ... ");
    };

    return (<>

        <Accordion expanded={expanded === 'TipoEnvio'} onChange={handleChangePanel('TipoEnvio')}>
            <AccordionSummary
                expandIcon={<Add />}
                aria-controls="panel1a-content"
                id="panel1a-header">
                <Typography component={'span'} className={classes.heading}>
                    {/* Tipo Envío */
                        traducirLabel(331)}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid item sm={12}>
                    <Box p={10} >

                        <Help comments={traducirMessage(63)} customStyle={{ bottom: "20px", right: "0" }} />

                        <Box mb={3} className="title text-center">
                            {/* Seleccione el tipo de envío que desea */traducirMessage(243)}
                        </Box>

                        <Grid container spacing={3} justify="center">
                            {props.tiposEnvio?.map(t =>
                                <TipoEnvio key={t.id} tipoEnvio={t} seleccionado={t.id === state.tipoEnvio?.id}
                                    onSelect={seleccionarTipoEnvio} icono={getIconoTipoEnvio(t.id)}/>

                            )}

                        </Grid>

                        {!errorCotizacion && ((props.cliente.habilitarClienteLogistico && !props.cliente.clienteConfiguracionMarkupDetalle.activo) 
                        || (!props.cliente.habilitarClienteLogistico && !props.cliente.clienteConfiguracionMarkupDetalle.activo)
                        || (!props.cliente.habilitarClienteLogistico && props.cliente.clienteConfiguracionMarkupDetalle.activo)) &&
                            < NextButton nextStep={generarCotizacion} label={traducirLabel(62)} />
                        }

                        {!errorCotizacion && (props.cliente.habilitarClienteLogistico && props.cliente.clienteConfiguracionMarkupDetalle.activo)  &&
                            < NextButton nextStep={generarCotizacion} label={traducirLabel(280)} />
                        }

                        {errorCotizacion && ((props.cliente.habilitarClienteLogistico && !props.cliente.clienteConfiguracionMarkupDetalle.activo) 
                        || (!props.cliente.habilitarClienteLogistico && !props.cliente.clienteConfiguracionMarkupDetalle.activo)
                        || (!props.cliente.habilitarClienteLogistico && props.cliente.clienteConfiguracionMarkupDetalle.activo)) &&
                            <Box display="flex" justifyContent="flex-end" mt={2}>
                                <Box>
                                    <Button variant="contained" color="primary" onClick={crearNuevaCotizacion}>
                                        {/* Crear Nueva Cotización */traducirLabel(62)}
                                    </Button>
                                </Box>
                            </Box>
                        }

                    </Box>
                </Grid>
            </AccordionDetails>
        </Accordion>
        {props.cliente.habilitarClienteLogistico && props.cliente.clienteConfiguracionMarkupDetalle.activo &&
        <Accordion expanded={expanded === 'Markup'} onChange={handleChangePanel('Markup')}>
            <AccordionSummary disabled={markupHabilitado}
                expandIcon={<Add />}
                aria-controls="panel1a-content"
                id="panel1a-header">
                <Typography component={'span'} className={classes.heading}>
                    {/*Markup */
                        traducirMessage(289)}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid item sm={12}>
                    {/* <Markup siguienteSeccion={handleSiguienteSeccion} cotizacionId={props.cotizacionId} cotizacionDTO={props.solicitudDTO}/> */}
                    <Markup siguienteSeccion={handleSiguienteSeccion} cotizacionId={totalValidaMarkup} solicitudDTO={props.solicitudDTO}/>
                </Grid>
            </AccordionDetails>
        </Accordion>
        }
        

        {
            showLoading &&
            <><LoadingDialog titulo={traducirLabel(240)} abierto={true} /> </>
        }
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    solicitud: state.solicitud,
    solicitudCopia: state.solicitudCopia,
    mercancias: state.mercancias,
    cliente: state.cliente,
    usuario: state.usuario,
    tiposEnvio: state.tiposEnvio,
    ayuda: state.ayuda
});

const mapDispatchToProps = {
    setSolicitudCopia: setSolicitudCopia,
    setSolicitud: setSolicitud,
    setRecoleccionOrigen: setRecoleccionOrigen,
    setRecoleccionDestino: setRecoleccionDestino,
    saveMercancias: saveMercancias,
    setUsuario: setUsuario,
    saveCliente: saveCliente
};

export default connect(mapStateToProps, mapDispatchToProps)(TipoEnvioLista);

